
export default {
    name: 'CirclePercent',
    props: {
        percent: {
            type: Number,
            default: 0,
            validator: v => v <= 100 && v >= 0
        }
    },
    computed: {
        degree () {
            return Math.floor((this.percent / 100) * 360)
        }
    }
}
